import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Box, AppBar, Toolbar, Typography, Button, Container, Tabs, Tab } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
  Logout as LogoutIcon,
  People as PeopleIcon,
  Storage as StorageIcon,
  Insights as InsightsIcon,
  Feedback as FeedbackIcon
} from '@mui/icons-material';
import { adminLogout, selectAdmin } from '../../store/reducers/adminAuthSlice';

const NAV_TABS = [
  { label: 'Users', path: '/admin/users', icon: <PeopleIcon fontSize="small" /> },
  { label: 'Database', path: '/admin/database', icon: <StorageIcon fontSize="small" /> },
  { label: 'Insights', path: '/admin/insights', icon: <InsightsIcon fontSize="small" /> },
  { label: 'Feedback', path: '/admin/feedback', icon: <FeedbackIcon fontSize="small" /> }
];

const AdminLayout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const admin = useSelector(selectAdmin);

  const handleLogout = async () => {
    await dispatch(adminLogout());
    navigate('/admin/login');
  };

  const currentTab = NAV_TABS.findIndex((t) => location.pathname.startsWith(t.path));

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      <AppBar position="static" sx={{ bgcolor: '#1976d2' }}>
        <Toolbar>
          <Typography variant="h6" sx={{ fontWeight: 600, mr: 4 }}>
            Realescy Admin Panel
          </Typography>
          <Tabs
            value={currentTab === -1 ? 0 : currentTab}
            onChange={(_, i) => navigate(NAV_TABS[i].path)}
            textColor="inherit"
            TabIndicatorProps={{ style: { backgroundColor: '#fff' } }}
            sx={{ flex: 1 }}
          >
            {NAV_TABS.map((tab) => (
              <Tab key={tab.path} label={tab.label} icon={tab.icon} iconPosition="start" sx={{ textTransform: 'none', minHeight: 64 }} />
            ))}
          </Tabs>
          <Typography variant="body2" sx={{ mr: 3 }}>
            {admin?.email || 'Admin'}
          </Typography>
          <Button color="inherit" startIcon={<LogoutIcon />} onClick={handleLogout} sx={{ textTransform: 'none' }}>
            Logout
          </Button>
        </Toolbar>
      </AppBar>

      <Container maxWidth="xl" sx={{ flex: 1, py: 4 }}>
        <Outlet />
      </Container>

      <Box
        component="footer"
        sx={{
          py: 2,
          px: 2,
          mt: 'auto',
          backgroundColor: '#fff',
          borderTop: '1px solid #e0e0e0'
        }}
      >
        <Typography variant="body2" color="text.secondary" align="center">
          © {new Date().getFullYear()} Realescy. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default AdminLayout;
